<template>
	<footer class="mt-auto pt-4">
		<div style="background-color: #669188; color: white;">
			<ImgFooter></ImgFooter>
			<div class="container">
				<footer class="row pt-5 pb-4">
					<div class="mb-3 col-sm-5 text-start">
						<p class="">" LET'S COLOR YOUR LIEF " <br /> บริษัท ทีโอเอ เพ้นท์ (ประเทศไทย) จำกัด (มหาชน)</p>
						<p class="">31/2 หมู่ 3 ถนนบางนา-ตราด ตำบลบางเสาธง อำเภอ <br /> บางเสาธง จังหวัด สมุทรปราการ
							10570</p>
						<p>ติดต่อเรา
							<br />
							สายตรงธุรกิจ: : <a href="tel:02-335-5555">02-335-5555</a>
							<br />
							สายตรงบริการลูกค้าสัมพันธ์: <a href="tel:02-335-5777">02-335-5777</a>
							<br />
							ฝ่ายบริการเครื่องผสมสีอัตโนมัติ: <a href="tel:02-335-5666">02-335-5666</a>
						</p>

					</div>
					<div class="mb-3 col-sm-3 text-start">
						<ul class="nav flex-column">
							<li class="nav-item  font_wh"><a
									href="https://www.toagroup.com/th/about-toa/company-info/vision"
									class="nav-link p-0 ">เกี่ยวกับ TOA</a></li>
							<li class="nav-item  font_wh"><a
									href="https://www.toagroup.com/th/palettes/colors/color-trends"
									class="nav-link p-0 ">ค้นหาสี</a></li>
							<li class="nav-item  font_wh"><a
									href="https://www.toagroup.com/th/palettes/design-service-by-toa-specialists/contact-and-request-for-color-design-service"
									class="nav-link p-0 ">บริการออกแบบสีบ้าน</a></li>
							<li class="nav-item  font_wh"><a
									href="https://www.toagroup.com/th/products/decorative-coatings"
									class="nav-link p-0 ">ผลิตภัณฑ์</a></li>
							<li class="nav-item  font_wh"><a href="https://www.toagroup.com/th/updates/corporate-news"
									class="nav-link p-0 ">ข่าวสารและกิจกรรม</a></li>
						</ul>
					</div>
					<div class="col-sm-4 mb-3">
						<ul class="nav flex-column text-start">
							<li class="nav-item "><a href="https://www.toagroup.com/th/products/stores"
									class="nav-link p-0 ">ค้นหาร้านค้า</a></li>
							<li class="nav-item "><a href="https://www.toagroup.com/th/blogs/toa-renovations"
									class="nav-link p-0 ">เคล็ดลับแก้ปัญหาซ่อมแซมบ้าน</a></li>
							<li class="nav-item "><a href="https://www.toagroup.com/th/updates/csr-activities"
									class="nav-link p-0 ">โครงการเพื่อสังคม</a></li>
							<li class="nav-item "><a href="https://investor.toagroup.com/th/home"
									class="nav-link p-0 ">นักลงทุนสัมพันธ์</a></li>
							<li class="nav-item "><a href="https://investor.toagroup.com/th/whistle-blowing"
									class="nav-link p-0 ">การแจ้งเบาะแสการทุจริต</a></li>
						</ul>
					</div>
				</footer>
			</div>
		</div>
		<FooterLC></FooterLC>
	</footer>
</template>

<script>
import ImgFooter from './ImgFooter'
import FooterLC from './FooterLC'
export default {
	components: { ImgFooter, FooterLC }
}
</script>

<style lang="scss" scoped>
a:link {
	color: white;
}

/* visited link */
a:visited {
	color: white;
}

/* mouse over link */
a:hover {
	color: white;
}

/* selected link */
a:active {
	color: white;
}

// Small devices (landscape phones, 576px and up)
@media (max-width: 390px) {
	.m_w_100_p {
		width: 100%;
	}
}
</style>